import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Card, Badge } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaEdit, FaTrash, FaBriefcase, FaMapMarkerAlt, FaCalendarAlt, FaPlus } from 'react-icons/fa';

function EducationEmploymentList({
  id,
  number,
  position,
  name,
  city,
  start_date,
  end_date,
  tasks,
  onDelete,
  onEdit, 
}) {
  const getIsSmall = () => typeof window !== 'undefined' ? window.innerWidth <= 444 : false;
  const [, setIsSmallScreen] = useState(getIsSmall);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(getIsSmall());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 20 }}
      transition={{ duration: 0.3 }}
      className="mt-3"
    >
      <Card 
        className="shadow-lg border-0" 
        style={{ 
          borderRadius: '20px', 
          overflow: 'hidden',
          cursor: 'pointer',
          transition: 'all 0.3s ease'
        }}
        onClick={() => onEdit && onEdit('form')}
      >
        <Card.Body style={{ padding: '1rem' }}>
          <Row className="align-items-center g-2">
            {/* NUMER */}
            <Col xs="auto">
              <div
                className="d-flex align-items-center justify-content-center text-white fw-bold rounded-circle"
                style={{
                  width: '45px',
                  height: '45px',
                  fontSize: '1.3rem',
                  background: 'linear-gradient(135deg, var(--bs-primary) 0%, #0056b3 100%)',
                  flexShrink: 0
                }}
              >
                {number}
              </div>
            </Col>

            {/* GŁÓWNA TREŚĆ */}
            <Col>
              {/* TYTUŁ */}
              <div className="d-flex align-items-center mb-1">
                <FaBriefcase className="text-primary me-2 d-none d-sm-inline" size={16} />
                <span className="fw-bold" style={{ fontSize: '0.95rem' }}>
                  {position ? `${position}, ${name}` : name}
                </span>
              </div>

              {/* LOKALIZACJA I DATA */}
              <div className="d-flex flex-wrap gap-2 mb-2">
                <Badge 
                  bg="light" 
                  text="dark" 
                  className="d-flex align-items-center"
                  style={{ fontSize: '0.8rem', fontWeight: '500' }}
                >
                  <FaMapMarkerAlt className="me-1" size={12} />
                  {city}
                </Badge>
                <Badge 
                  bg="light" 
                  text="dark"
                  className="d-flex align-items-center"
                  style={{ fontSize: '0.8rem', fontWeight: '500' }}
                >
                  <FaCalendarAlt className="me-1" size={12} />
                  {start_date} - {end_date}
                </Badge>
              </div>

              {/* ZADANIA LUB DODAJ OPIS */}
              {tasks && tasks.length > 0 ? (
                <div 
                  className="mt-2 p-2"
                  style={{
                    background: 'rgba(var(--bs-primary-rgb), 0.05)',
                    borderRadius: '10px',
                    fontSize: '0.85rem'
                  }}
                >
                  <ul className="mb-0" style={{ paddingLeft: '1.2rem' }}>
                    {tasks.map((task, i) => (
                      <li key={i} style={{ fontSize: '0.85rem' }}>
                        <small>{task}</small>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div
                  className="text-primary fst-italic mt-2"
                  style={{
                    cursor: 'pointer',
                    fontSize: '0.85rem',
                    transition: 'all 0.2s ease',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit && onEdit('description');
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.textDecoration = 'underline';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.textDecoration = 'none';
                  }}
                >
                  <FaPlus size={12} className="me-1" />
                  Dodaj opis
                </div>
              )}
            </Col>
            
            {/* PRZYCISKI */}
            <Col
              xs={12}
              sm="auto"
              className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0"
            >
              <div className="btn-group" role="group">
                <Button
                  variant="outline-warning"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit && onEdit('form');
                  }}
                  style={{ 
                    borderRadius: '10px 0 0 10px', 
                    padding: '0.4rem 0.6rem', 
                    fontSize: '0.85rem' 
                  }}
                >
                  <FaEdit />
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete && onDelete();
                  }}
                  style={{ 
                    borderRadius: '0 10px 10px 0', 
                    padding: '0.4rem 0.6rem', 
                    fontSize: '0.85rem' 
                  }}
                >
                  <FaTrash />
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </motion.div>
  );
}

export default EducationEmploymentList;